import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  CatalogAnnotationsClient,
  catalogAnnotationsApiRef,
} from './catalogAnnotationsApi';

export const catalogAnnotationsApiModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    ApiBlueprint.make({
      name: 'catalog-annotations',
      params: params =>
        params({
          api: catalogAnnotationsApiRef,
          deps: {
            discoveryApi: discoveryApiRef,
            fetchApi: fetchApiRef,
          },
          factory: ({ discoveryApi, fetchApi }) =>
            new CatalogAnnotationsClient(discoveryApi, fetchApi),
        }),
    }),
  ],
});
